import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { Observable } from 'rxjs';
import { RankingDefinition } from './ranking-definition';
import {Ranking, RankingParams, RankingWithKpiMapAndExtras} from './ranking.interface';
import { MapOfNumberTo } from '../../interfaces/utils';

/*
  Generated class for the RankingServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RankingServiceProvider {
  rankingsIds = null;
  rankings = null;
  rankingsDefinitions = null;
  rankingFilters = null;
  rankingGroupFilters = null;
  rankingHistoryFilters = null;

  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {}

  load() {
    return Promise.all([this.loadAndSaveRankingsDefinitions(), this.loadAndSaveRankings()]);
  }

  private loadAndSaveRankingsDefinitions() {
    return this.loadRankingDefinitions()
      .toPromise()
      .then((response) => this.storageService.setObject('rankingDefinitions', response));
  }

  private loadAndSaveRankings() {
    return this.loadRankings()
      .toPromise()
      .then((response) => {
        const rankings: Ranking[] = response;
        const mapRankings = {}
        const objectRankings = {}

        for (let ranking in rankings) {
          const currentRanking: Ranking = rankings[ranking];

          this.prepareRankings(mapRankings, currentRanking);
          this.prepareRankings(objectRankings, currentRanking);

          const mapRankingElement = mapRankings[currentRanking.rankingId][this.getParticipantId(currentRanking)];
          const objectRankingElement = objectRankings[currentRanking.rankingId][this.getParticipantId(currentRanking)];
          const clonedCurrentRanking = this.cloneRanking(currentRanking);

          mapRankingElement.push(clonedCurrentRanking)

          const clonedCurrentRankingKpiMap = this.cloneRanking(currentRanking);

          clonedCurrentRankingKpiMap.params.kpis = {}

          for (let kpi in clonedCurrentRanking.params.kpis) {
            const kpiValue = clonedCurrentRanking.params.kpis[kpi];

            clonedCurrentRankingKpiMap.params.kpis[kpiValue["kpiId"]] = kpiValue
          }

          objectRankingElement.push(clonedCurrentRankingKpiMap)
        }

        return Promise.all([
          this.storageService.setObject('rankings', objectRankings),
          this.storageService.setObject('rankingsByDefIdAndParticipantId', mapRankings),
        ]);
      });
  }

  private getParticipantId(ranking: Ranking): number {
    return ranking.userGroupingType === 'GROUP' ? ranking.groupId : ranking.userId;
  }

  private cloneRanking(currentRanking: Ranking) {
    const clonedCurrentRanking = JSON.parse(JSON.stringify(currentRanking));

    if (!clonedCurrentRanking.params)
      clonedCurrentRanking.params = {} as RankingParams

    if (!clonedCurrentRanking.params.kpis)
      clonedCurrentRanking.params.kpis = []

    return clonedCurrentRanking;
  }

  private prepareRankings(rankings: {}, currentRanking: Ranking) {
    if (!rankings[currentRanking.rankingId])
      rankings[currentRanking.rankingId] = {}

    if (!rankings[currentRanking.rankingId][this.getParticipantId(currentRanking)])
      rankings[currentRanking.rankingId][this.getParticipantId(currentRanking)] = []
  }

  private loadRankingDefinitions(): Observable<RankingDefinition[]> {
    return this.http.get<RankingDefinition[]>(this.configService.getUrl('rankingDefinitions'));
  }

  loadRankings(): Observable<Ranking[]> {
    return this.http.get<Ranking[]>(this.configService.getUrl('rankings'));
  }

  getRankingDefinitions(): Promise<RankingDefinition[]> {
    return this.storageService.getObject('rankingDefinitions');
  }

  getRankings(): Promise<MapOfNumberTo<MapOfNumberTo<RankingWithKpiMapAndExtras[]>>> {
    return this.storageService.getObject('rankings');
  }

  getRankingsByDefIdAndParticipantId(): Promise<MapOfNumberTo<MapOfNumberTo<Ranking[]>>> {
    return this.storageService.getObject('rankingsByDefIdAndParticipantId');
  }

  setFilters(object): Promise<void> {
    return this.storageService.setObject('rankingFilters', object);
  }

  getFilters() {
    return this.storageService.getObject('rankingFilters');
  }

  setGroupFilters(object): Promise<void> {
    return this.storageService.setObject('rankingGroupFilters', object);
  }

  getGroupFilters() {
    return this.storageService.getObject('rankingGroupFilters');
  }

  setHistoryFilters(object): Promise<void> {
    return this.storageService.setObject('rankingHistoryFilters', object);
  }

  getHistoryFilters() {
    return this.storageService.getObject('rankingHistoryFilters');
  }

  //TODO nieużywane, ale feature przeglądania starszych wyników by się przydał
  getRankingHistory(id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('history') + id + '/history')
        .toPromise()
        .then((result) => {
          resolve();
        })
        .catch((err) => {
          console.error(err);
          reject();
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/ranking-service/ranking-service.ts